function notifyBulkAlbums(msg, type) {
  if (window.siteUi && typeof window.siteUi.showNotification === "function") {
    window.siteUi.showNotification({ message: msg, type: type || "info" })
  } else {
    window.alert(msg)
  }
}

function initMediaAlbumsBulkPermissions() {
  const bar = document.getElementById("media-albums-bulk-bar")
  if (!bar) return

  const url = bar.dataset.bulkUrl
  if (!url) return

  const tokenEl = document.querySelector('meta[name="csrf-token"]')
  const csrf = tokenEl ? tokenEl.getAttribute("content") : ""

  function selectedIds() {
    return Array.from(document.querySelectorAll(".media-album-cb:checked")).map((cb) =>
      parseInt(cb.value, 10)
    )
  }

  function updateBulkUi() {
    const n = selectedIds().length
    const countEl = document.getElementById("media-albums-bulk-count")
    if (countEl) countEl.textContent = String(n)
    bar.querySelectorAll(".media-albums-bulk-btn").forEach((btn) => {
      btn.disabled = n === 0
    })
  }

  document.getElementById("media-albums-select-all")?.addEventListener("click", () => {
    document.querySelectorAll(".media-album-cb").forEach((cb) => {
      cb.checked = true
    })
    updateBulkUi()
  })

  document.getElementById("media-albums-clear")?.addEventListener("click", () => {
    document.querySelectorAll(".media-album-cb").forEach((cb) => {
      cb.checked = false
    })
    updateBulkUi()
  })

  document.querySelector(".media-albums-index")?.addEventListener("change", (e) => {
    if (e.target && e.target.classList.contains("media-album-cb")) updateBulkUi()
  })

  bar.querySelectorAll(".media-albums-bulk-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const visibility = btn.dataset.visibility
      const ids = selectedIds()
      if (!visibility || ids.length === 0) return

      const body = new URLSearchParams()
      ids.forEach((id) => body.append("album_ids[]", id))
      body.append("visibility", visibility)
      body.append("authenticity_token", csrf)

      btn.disabled = true

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-CSRF-Token": csrf,
          Accept: "application/json",
        },
        body: body.toString(),
        credentials: "same-origin",
      })
        .then((r) => {
          const ct = r.headers.get("content-type") || ""
          if (!ct.includes("application/json")) {
            throw new Error("not json")
          }
          return r.json().then((data) => ({ ok: r.ok, data }))
        })
        .then((res) => {
          if (res.data && res.data.success) {
            notifyBulkAlbums(res.data.message, "success")
            window.location.reload()
          } else {
            notifyBulkAlbums((res.data && res.data.message) || "Could not update albums.", "error")
          }
        })
        .catch(() => {
          notifyBulkAlbums("Could not update albums.", "error")
        })
        .finally(() => {
          updateBulkUi()
        })
    })
  })

  updateBulkUi()
}

document.addEventListener("turbolinks:load", initMediaAlbumsBulkPermissions)
